/* global runtime, authorizedPost, applyVatMutationResult */
// Opening corrections use the same authorized, audited profile boundary.
const mutateOpeningFigures = async (payload) => {
  const result = await authorizedPost('businessProfileMutationHttp', { ...payload, businessId: runtime.activeBusinessId });
  applyVatMutationResult(result);
  return result;
};
